import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-recipient-modal.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-recipient-modal.component.scss?ngResource";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { DefaultRequiredFields } from "../../../../../models/application/generic/recipient.model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../constants/shared.constants";
import { RecipientFormConstants } from "../../shared-contants/recipient-shared.constants";
import { RecipientService } from "../../shared-services/recipient.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../../../app-controller.service";
import RecipientUtils from "../../../../../utils/recipient-utils";
import { AlertType } from "../../../../../models/alert";
import { phoneNumberValidator } from "../../../../../classes/phone-number-validator";
import { RecipientSelectConstants } from "../../../recipient-select/recipient-select.constants";
import { LookupConstants } from "../../../../../constants/lookup.constants";
import { take } from "rxjs";
import { AppConfig } from "../../../../../../app.config";
let AddRecipientModalComponent = class AddRecipientModalComponent {
    changeDetectorRef;
    recipientService;
    activeModal;
    appControllerService;
    dialogTitle = "Add new recipient";
    configurableLabel = "Recipient details";
    groupsFromMetadata = [];
    jobId;
    moduleId;
    groupsOptions = [];
    showRecipientsGroupsDropdown = true;
    showDefaultCommunicationMethod = false;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    newRecipientForm;
    Validator = Validators;
    sameAsResidentialChecked = false;
    disableEditing = false;
    emailRequired = false;
    smsRequired = false;
    provinceOptions = LookupConstants.PROVINCE;
    countryOptions = LookupConstants.COUNTRIES;
    defaultRequiredFields = DefaultRequiredFields;
    maritalStatusOptions = LookupConstants.MARITAL_STATUS_LOOKUPS_RECIPIENT_COMPONENTS;
    employmentStatusOptions = LookupConstants.EMPLOYMENT_STATUS_LOOKUPS_RECIPIENT_COMPONENTS;
    selectOptionText = SharedConstants.NO_OPTION_SELECTED;
    recipientGroupSettings = [];
    employersDetailsHeader = RecipientSelectConstants.employerDetailsHeader;
    formName = "addNewRecipient";
    validationMessage = RecipientFormConstants.validationMessage;
    nameLabel = RecipientFormConstants.nameLabel;
    surnameLabel = RecipientFormConstants.surnameLabel;
    homePhoneTelephoneLabel = RecipientFormConstants.homeTelePhoneLabel;
    workTelephoneLabel = RecipientFormConstants.workTelephoneLabel;
    cellphoneLabel = RecipientFormConstants.cellphoneLabel;
    emailLabel = RecipientFormConstants.emailLabel;
    smsRadioButtonLabel = RecipientFormConstants.smsRadioButtonLabel;
    defaultCommunicationMethodLabel = RecipientFormConstants.defaultCommunicationMethodLabel;
    emailRadioButtonLabel = RecipientFormConstants.emailRadioButtonLabel;
    organisationLabel = RecipientFormConstants.organisationLabel;
    clientVatNumberLabel = RecipientFormConstants.clientVatNumberLabel;
    designationLabel = RecipientFormConstants.designationLabel;
    professionalBodyHeader = RecipientFormConstants.professionalBodyHeader;
    relativeDetailsBodyLabel = RecipientSelectConstants.relativeDetailsBodyLabel;
    professionalBodyLabel = RecipientFormConstants.professionalBodyLabel;
    professionalBodyRegNoLabel = RecipientFormConstants.professionalBodyRegNoLabel;
    maritalStatusLabel = RecipientSelectConstants.maritalStatusLabel;
    idNumberLabel = RecipientSelectConstants.idNumberLabel;
    relativesFullNameLabel = RecipientSelectConstants.relativesFullNameLabel;
    relativesContactNumberLabel = RecipientSelectConstants.relativesContactNumberLabel;
    relativesAddressLabel = RecipientSelectConstants.relativesAddressLabel;
    employmentStatusLabel = RecipientSelectConstants.employmentStatusLabel;
    employersNameLabel = RecipientSelectConstants.employersNameLabel;
    employersContactNumberLabel = RecipientSelectConstants.employersContactNumberLabel;
    employersAddressLabel = RecipientSelectConstants.employersAddressLabel;
    streetAddressHeader = RecipientFormConstants.streetAddressHeader;
    streetAddressLabel = RecipientFormConstants.streetAddressLabel;
    streetSuburbLabel = RecipientFormConstants.streetSuburbLabel;
    streetCityLabel = RecipientFormConstants.streetCityLabel;
    streetProvinceLabel = RecipientFormConstants.streetProvinceLabel;
    streetCountryLabel = RecipientFormConstants.streetCountryLabel;
    streetCodeLabel = RecipientFormConstants.streetCodeLabel;
    postalDetailsHeader = RecipientFormConstants.postalDetailsHeader;
    postalAddressLabel = RecipientFormConstants.postalAddressLabel;
    postalSuburbLabel = RecipientFormConstants.postalSuburbLabel;
    postalCityLabel = RecipientFormConstants.postalCityLabel;
    postalProvinceLabel = RecipientFormConstants.postalProvinceLabel;
    postalCountryLabel = RecipientFormConstants.postalCountryLabel;
    postalCodeLabel = RecipientFormConstants.postalCodeLabel;
    sameAsStreetAddressLabel = RecipientFormConstants.sameAsStreetAddressLabel;
    groupsHeader = RecipientFormConstants.groups;
    groupsLabel = RecipientFormConstants.groupsLabel;
    // Form Controls
    nameFormControlName = RecipientFormConstants.nameFormControl;
    surnameFormControlName = RecipientFormConstants.surnameFormControl;
    homePhoneFormControlName = RecipientFormConstants.homeTelePhoneFormControl;
    workTelephoneFormControlName = RecipientFormConstants.workTelephoneFormControl;
    cellphoneFormControlName = RecipientFormConstants.cellphoneFormControlName;
    defaultCommunicationMethodFormControlName = RecipientFormConstants.defaultCommunicationMethodFormControlName;
    emailFormControlName = RecipientFormConstants.emailFormControlName;
    organisationFormControlName = RecipientFormConstants.organisationFormControlName;
    clientVatNumberFormControlName = RecipientFormConstants.clientVatNumberFormControlName;
    designationFormControlName = RecipientFormConstants.designationFormControlName;
    professionalBodyFormControlName = RecipientFormConstants.professionalBodyFormControlName;
    maritalStatusFormControlName = RecipientSelectConstants.maritalStatusFormControlName;
    relativesFullNameFormControlName = RecipientSelectConstants.relativesFullNameFormControlName;
    relativesContactNumberFormControlName = RecipientSelectConstants.relativesContactNumberFormControlName;
    relativesAddressFormControlName = RecipientSelectConstants.relativesAddressFormControlName;
    employmentStatusFormControlName = RecipientSelectConstants.employmentStatusFormControlName;
    employersNameFormControlName = RecipientSelectConstants.employersNameFormControlName;
    employersContactNumberFormControlName = RecipientSelectConstants.employersContactNumberFormControlName;
    employersAddressFormControlName = RecipientSelectConstants.employersAddressFormControlName;
    idNumberFormControlName = RecipientSelectConstants.idNumberFormControlName;
    professionalBodyRegNoFormControlName = RecipientFormConstants.professionalBodyRegNoFormControlName;
    streetAddressFormControlName = RecipientFormConstants.streetAddressFormControlName;
    streetSuburbFormControlName = RecipientFormConstants.streetSuburbFormControlName;
    streetCityFormControlName = RecipientFormConstants.streetCityFormControlName;
    streetProvinceFormControlName = RecipientFormConstants.streetProvinceFormControlName;
    streetCountryFormControlName = RecipientFormConstants.streetCountryFormControlName;
    streetCodeFormControlName = RecipientFormConstants.streetCodeFormControlName;
    postalAddressFormControlName = RecipientFormConstants.postalAddressFormControlName;
    postalSuburbFormControlName = RecipientFormConstants.postalSuburbFormControlName;
    postalCityFormControlName = RecipientFormConstants.postalCityFormControlName;
    postalProvinceFormControlName = RecipientFormConstants.postalProvinceFormControlName;
    postalCountryFormControlName = RecipientFormConstants.postalCountryFormControlName;
    postalCodeFormControlName = RecipientFormConstants.postalCodeFormControlName;
    groupsStringArrayFormControlName = RecipientFormConstants.groupsStringArrayFormControlName;
    selectOptionTextOption = RecipientFormConstants.PLEASE_SELECT_AN_OPTION;
    maximunLengthForThentyWord = 20;
    maximunLengthForFiftyWord = 50;
    maximunLengthForHundredWord = 100;
    maximunLengthForTwoFiftyWord = 250;
    maximunLengthFiveHundredWord = 500;
    cancelBtnPlaceholder = SharedConstants.CANCEL_LABEL;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    newRecipientFormLabelHeading = "Recipient details";
    requiredFieldsPlaceHolder = RecipientFormConstants.requireFieldKey;
    // control visibility
    showNameField = true;
    showSurnameField = true;
    showHomeTelephoneField = true;
    showWorkTelephoneField = true;
    showCellphoneField = true;
    showEmailField = true;
    showOrganisationField = true;
    showDesignationField = true;
    showProfessionalBodyField = true;
    showProfessionalBodyRegNumField = true;
    showStreetAddressField = true;
    showStreetSuburbField = true;
    showStreetCityField = true;
    showStreetProvinceField = true;
    showStreetCountryField = true;
    showStreetCodeField = true;
    showPostalAddressField = true;
    showPostalSuburbField = true;
    showPostalCityField = true;
    showPostalProvinceField = true;
    showPostalCountryField = true;
    showPostalCodeField = true;
    showMaritalStatusField = false;
    showRelativesFullNameField = false;
    showRelativesContactNumberField = false;
    showRelativesAddressField = false;
    showEmploymentStatusField = false;
    showEmployersNameField = false;
    showEmployersContactNumberField = false;
    showEmployersAddressField = false;
    showIdNumberField = false;
    showClientVatNumberField = false;
    showSave = true;
    constructor(changeDetectorRef, recipientService, activeModal, appControllerService) {
        this.changeDetectorRef = changeDetectorRef;
        this.recipientService = recipientService;
        this.activeModal = activeModal;
        this.appControllerService = appControllerService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.initForm();
        this.loadRecipientGroupSettings();
        this.populateRecipientGroups();
        this.showOrHideGroupsDropdown();
        this.setConfigurableLabel();
        this.changeDetectorRef.markForCheck();
    }
    loadRecipientGroupSettings() {
        if (this.recipientGroupSettings.length === 0) {
            this.recipientService.getRecipientGroupSettings(+this.appControllerService.selectedModuleID, false).pipe(take(1)).subscribe({
                next: (response) => {
                    this.recipientGroupSettings = response;
                    this.checkRequiredFields();
                    this.checkCommunicationMethods();
                }, error: (error) => {
                    this.appControllerService.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
                }
            });
        }
    }
    onResidentialInputEntered($event, postalAddressFormControlName) {
        RecipientUtils.onResidentialInputEntered($event, postalAddressFormControlName, this.newRecipientForm, this.sameAsResidentialChecked);
    }
    onSameAsResidentialChecked($event) {
        const checkBoxStatus = $event.target.checked;
        if (checkBoxStatus) {
            this.sameAsResidentialChecked = true; // checks the checkbox and disables fields
            RecipientUtils.copyStreetDetailsDataToPostalDetailsFields(this.newRecipientForm, this.sameAsResidentialChecked);
            RecipientUtils.clearPostalDetailsValidators(this.newRecipientForm, this.sameAsResidentialChecked);
        }
        else {
            this.sameAsResidentialChecked = false;
            RecipientUtils.restorePostalDetailsValidators(this.newRecipientForm, this.groupsFromMetadata);
            this.newRecipientForm.updateValueAndValidity();
            this.changeDetectorRef.detectChanges();
        }
    }
    enablePostalSelects(postalProvinceFormControlName) {
        RecipientUtils.enablePostalSelects(this.newRecipientForm, postalProvinceFormControlName, this.sameAsResidentialChecked);
    }
    disablePostalSelects(postalProvinceFormControlName) {
        RecipientUtils.disablePostalSelects(this.newRecipientForm, postalProvinceFormControlName, this.sameAsResidentialChecked);
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onSaveBtnClicked() {
        this.newRecipientForm.updateValueAndValidity();
        if (this.newRecipientForm.valid) {
            const newRecipient = this.newRecipientForm.value;
            newRecipient.id = 0;
            newRecipient.jobId = this.jobId ? this.jobId : null;
            newRecipient.moduleId = this.moduleId;
            this.activeModal.close(newRecipient);
        }
        else {
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    onRadioButtonChanged(selectedMethodOfCommunication) {
        const preferredMethodOfCommunication = selectedMethodOfCommunication.trim().toLowerCase();
        const emailFormControl = this.newRecipientForm.get(this.emailFormControlName);
        const cellphoneFormControl = this.newRecipientForm.get(this.cellphoneFormControlName);
        emailFormControl.clearValidators();
        cellphoneFormControl.clearValidators();
        if (preferredMethodOfCommunication === "email") {
            if (this.emailRequired) {
                emailFormControl.setValidators([Validators.required, Validators.email]);
            }
            cellphoneFormControl.clearValidators();
        }
        else if (preferredMethodOfCommunication === "sms") {
            if (this.smsRequired) {
                cellphoneFormControl.setValidators([Validators.required, phoneNumberValidator]);
            }
            emailFormControl.clearValidators();
        }
        else {
            emailFormControl.clearValidators();
            cellphoneFormControl.clearValidators();
        }
        emailFormControl.updateValueAndValidity();
        cellphoneFormControl.updateValueAndValidity();
    }
    initForm() {
        this.newRecipientForm = new FormGroup({
            id: new FormControl(),
            jobId: new FormControl(),
            moduleId: new FormControl(),
            name: new FormControl(),
            surname: new FormControl(),
            homePhone: new FormControl(null, phoneNumberValidator),
            telephone: new FormControl(null, phoneNumberValidator),
            cellphone: new FormControl(null, phoneNumberValidator),
            defaultCommunicationMethod: new FormControl("Email"),
            email: new FormControl(null, Validators.email),
            organisation: new FormControl(),
            clientVatNumber: new FormControl(),
            designation: new FormControl(),
            professionalBody: new FormControl(),
            professionalBodyRegNum: new FormControl(),
            maritalStatus: new FormControl(),
            relativesFullName: new FormControl(),
            relativesContactNumber: new FormControl(null, phoneNumberValidator),
            idNumber: new FormControl(),
            relativesAddress: new FormControl(),
            employmentStatus: new FormControl(),
            employersName: new FormControl(),
            employersContactNumber: new FormControl(),
            employersAddress: new FormControl(),
            streetAddress: new FormControl(),
            streetSuburb: new FormControl(),
            streetCity: new FormControl(),
            streetProvince: new FormControl(),
            streetCountry: new FormControl(SharedConstants.DEFAULT_COUNTRY),
            streetCode: new FormControl(),
            postalAddress: new FormControl(),
            postalSuburb: new FormControl(),
            postalCity: new FormControl(),
            postalProvince: new FormControl(),
            postalCountry: new FormControl(SharedConstants.DEFAULT_COUNTRY),
            postalCode: new FormControl(),
            groupsStringArray: new FormControl([], Validators.required),
            groups: new FormControl([])
        });
    }
    populateRecipientGroups() {
        // populates the groups dropdown
        this.groupsOptions?.sort((a, b) => a?.localeCompare(b));
        if (this.groupsOptions.length === 1) {
            this.newRecipientForm.get(this.groupsStringArrayFormControlName).setValue([this.groupsOptions[0]]);
        }
    }
    checkRequiredFields() {
        const group = this.groupsFromMetadata[0];
        if (this.recipientGroupSettings.length > 0) {
            const settings = this.recipientGroupSettings.find(x => (x.name === group.groupName || x.name === group?.GroupName) && (x.type === group.groupType || x.type === group?.GroupType));
            if (settings) {
                group.requiredFields = JSON.parse(settings.configuration);
                this.loadRequiredFields(group);
                this.newRecipientForm.updateValueAndValidity();
            }
            else {
                this.showSave = false;
                this.appControllerService.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
            }
        }
        else {
            this.showSave = false;
            this.appControllerService.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
        }
    }
    showOrHideGroupsDropdown() {
        if (this.showRecipientsGroupsDropdown && this.groupsOptions.length > 1) {
            this.showRecipientsGroupsDropdown = true;
        }
        else {
            this.showRecipientsGroupsDropdown = false;
        }
    }
    setConfigurableLabel() {
        this.newRecipientFormLabelHeading = this.configurableLabel;
    }
    loadRequiredFields(data) {
        data.requiredFields.forEach((item) => {
            item.name = this.formatObjectKey(item.name);
            const control = this.newRecipientForm.get(item.name);
            if (item.required) {
                control.addValidators([Validators.required]);
                if (item.name === RecipientFormConstants.homeTelePhoneFormControl) {
                    control.addValidators([phoneNumberValidator]);
                }
                if (item.name === RecipientFormConstants.workTelephoneFormControl) {
                    control.addValidators([phoneNumberValidator]);
                }
                if (item.name === RecipientFormConstants.cellphoneFormControlName) {
                    this.smsRequired = true;
                    control.addValidators([phoneNumberValidator]);
                }
                if (item.name === RecipientFormConstants.streetCodeFormControlName) {
                    control.addValidators([Validators.minLength(4)]);
                }
                if (item.name === RecipientFormConstants.postalCodeFormControlName) {
                    control.addValidators([Validators.minLength(4)]);
                }
                if (item.name === RecipientFormConstants.emailFormControlName) {
                    this.emailRequired = true;
                    control.addValidators([Validators.email]);
                }
                if (item.name === RecipientFormConstants.defaultCommunicationMethodFormControlName) {
                    // Optional: If this is a requirement for email or SMS, handle it here.
                }
                control.updateValueAndValidity();
            }
            this.showOrHideControl(item.name, item.visible);
        });
        this.newRecipientForm.updateValueAndValidity();
        this.changeDetectorRef.markForCheck();
    }
    formatObjectKey(name) {
        const wordArr = name.split(" ");
        wordArr.forEach((word, index) => {
            wordArr[index] = word.charAt(0).toUpperCase() + word.slice(1);
        });
        name = wordArr.join("");
        let keyToChange = name;
        if (keyToChange.toLocaleLowerCase() === "professionalbodyregistrationnumber") {
            keyToChange = "professionalBodyRegNum";
        }
        if (keyToChange === "Homephone") {
            keyToChange = "HomePhone";
        }
        const formattedString = keyToChange.charAt(0).toLowerCase() + keyToChange.slice(1);
        return formattedString;
    }
    setEmailFormFieldAsRequired(emailFormControl) {
        emailFormControl.setValidators([Validators.required, Validators.email]);
        emailFormControl.updateValueAndValidity();
    }
    setCellphoneFormFieldAsRequired(cellphoneFormControl) {
        cellphoneFormControl.setValidators([Validators.required, phoneNumberValidator]);
        cellphoneFormControl.updateValueAndValidity();
    }
    clearCellphoneFormFieldRequiredValidation(cellphoneFormControl) {
        cellphoneFormControl.clearValidators();
        cellphoneFormControl.addValidators(phoneNumberValidator);
    }
    clearEmailFormFieldRequiredValidation(emailFormControl) {
        emailFormControl.clearValidators();
        emailFormControl.addValidators(Validators.email);
    }
    ngAfterViewInit() {
        this.setFormDefaults();
    }
    setFormDefaults() {
        this.newRecipientForm.get(this.postalCountryFormControlName).setValue(SharedConstants.DEFAULT_COUNTRY);
        this.newRecipientForm.get(this.streetCountryFormControlName).setValue(SharedConstants.DEFAULT_COUNTRY);
        this.changeDetectorRef.detectChanges();
    }
    showOrHideControl(controlName, visible) {
        switch (controlName) {
            case this.nameFormControlName:
                this.showNameField = visible;
                break;
            case this.surnameFormControlName:
                this.showSurnameField = visible;
                break;
            case this.homePhoneFormControlName:
                this.showHomeTelephoneField = visible;
                break;
            case this.workTelephoneFormControlName:
                this.showWorkTelephoneField = visible;
                break;
            case this.cellphoneFormControlName:
                this.showCellphoneField = visible;
                break;
            case this.emailFormControlName:
                this.showEmailField = visible;
                break;
            case this.idNumberFormControlName:
                this.showIdNumberField = visible;
                break;
            case this.organisationFormControlName:
                this.showOrganisationField = visible;
                break;
            case this.designationFormControlName:
                this.showDesignationField = visible;
                break;
            case this.professionalBodyFormControlName:
                this.showProfessionalBodyField = visible;
                break;
            case this.professionalBodyRegNoFormControlName:
                this.showProfessionalBodyRegNumField = visible;
                break;
            case this.maritalStatusFormControlName:
                this.showMaritalStatusField = visible;
                break;
            case this.relativesFullNameFormControlName:
                this.showRelativesFullNameField = visible;
                break;
            case this.clientVatNumberFormControlName:
                this.showClientVatNumberField = visible;
                break;
            case this.relativesContactNumberFormControlName:
                this.showRelativesContactNumberField = visible;
                break;
            case this.relativesAddressFormControlName:
                this.showRelativesAddressField = visible;
                break;
            case this.employmentStatusFormControlName:
                this.showEmploymentStatusField = visible;
                break;
            case this.employersNameFormControlName:
                this.showEmployersNameField = visible;
                break;
            case this.employersContactNumberFormControlName:
                this.showEmployersContactNumberField = visible;
                break;
            case this.employersAddressFormControlName:
                this.showEmployersAddressField = visible;
                break;
            case this.streetAddressFormControlName:
                this.showStreetAddressField = visible;
                break;
            case this.streetCityFormControlName:
                this.showStreetCityField = visible;
                break;
            case this.streetSuburbFormControlName:
                this.showStreetSuburbField = visible;
                break;
            case this.streetProvinceFormControlName:
                this.showStreetProvinceField = visible;
                break;
            case this.streetCountryFormControlName:
                this.showStreetCountryField = visible;
                break;
            case this.streetCodeFormControlName:
                this.showStreetCodeField = visible;
                break;
            case this.postalAddressFormControlName:
                this.showPostalAddressField = visible;
                break;
            case this.postalCityFormControlName:
                this.showPostalCityField = visible;
                break;
            case this.postalSuburbFormControlName:
                this.showPostalSuburbField = visible;
                break;
            case this.postalProvinceFormControlName:
                this.showPostalProvinceField = visible;
                break;
            case this.postalCountryFormControlName:
                this.showPostalCountryField = visible;
                break;
            case this.postalCodeFormControlName:
                this.showPostalCodeField = visible;
                break;
            default:
                break;
        }
    }
    checkCommunicationMethods() {
        if (this.showDefaultCommunicationMethod) {
            const defaultCommunicationMethod = this.newRecipientForm.get(this.defaultCommunicationMethodFormControlName).value;
            this.onRadioButtonChanged(defaultCommunicationMethod);
        }
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: RecipientService },
        { type: NgbActiveModal },
        { type: AppControllerService }
    ];
    static propDecorators = {
        dialogTitle: [{ type: Input }],
        configurableLabel: [{ type: Input }],
        groupsFromMetadata: [{ type: Input }],
        jobId: [{ type: Input }],
        moduleId: [{ type: Input }],
        groupsOptions: [{ type: Input }],
        showRecipientsGroupsDropdown: [{ type: Input }],
        showDefaultCommunicationMethod: [{ type: Input }]
    };
};
AddRecipientModalComponent = __decorate([
    Component({
        selector: "app-add-recipient-modal",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AddRecipientModalComponent);
export { AddRecipientModalComponent };
